import React, { useState, useEffect, useCallback } from "react";
import { instance } from "../../axios";
import { rupees } from "../../helper";
import { BgLoader, UiInput, UiButton } from "../../ui";
import { useForm, Controller } from "react-hook-form";
import { useNavigate, useOutletContext } from "react-router-dom";
import { toast } from "react-toastify";
import { Helmet } from "react-helmet";

import { PaymentForm } from '../../pay_form'

export default function Payment() {
  let navigate = useNavigate();
  

  const [state, setState] = useState({});
  

  const [pstate, setTitle] = useOutletContext(); // <-- access context value



  useEffect(() => {
    setTitle('Online Payment')
  }, []);



  return (
    <div>
      <Helmet>
        <title>Online Payment</title>
        {pstate.company && pstate.company.logo  &&  <link rel="icon" type="image/x-icon" href={pstate.company.logo}></link>}
      </Helmet>

      <div className="row d-flex justify-content-center align-items-center">
        <div className="col-12 col-md-6 col-lg-6 col-xl-6 px-4">
         <PaymentForm pg={pstate.company.pg} razorpay_key={pstate.company.razorpay_key} name={pstate.company.name} company={pstate.company.company} mobile={pstate.company.mobile} cid={pstate.company.id}/>
        </div>
      </div>

    </div>
  );
}
